/* eslint-disable no-inner-declarations */
import React, { createContext, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// slice
import { effciencyApi } from "../../../../app/services/efficiencyApi";
import { exportCmdbAppConfigCSV } from "./CMDBSlice";
import { CmdbList } from "./appConfigSlice";
// import { setAppConfig } from "../../DevopsInsights/Efficiency/efficiencySlice";
import { setAppConfig } from "./efficienySlice";

// Assets
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { iconElipsis, settingsCode8 } from "../../../../assets/images";

//Components
import ShowTooltip from "../../../../app/common-components/Tooltip/showToolTip";



import { useCommonAlert } from "../../../../app/utilities/helpers";
import DeleteModal from "./CmdbAppDeleteModal";

// Internall Comp
import NewCmdbConfig from "./NewCmdbConfig";

// 3rd Party Libraries
import { BiImport, BiSolidFolderOpen } from "react-icons/bi";
import { FaCloud, FaServer, FaUserAlt } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { TiExport } from "react-icons/ti";
import GetProxy from "../../../../app/GetProxy";
// import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { get, isEmpty } from "lodash";

// styles
import "../styles.scss";
// import "../../DevopsInsights/Efficiency/efficiency.scss";


export const AppConfigContext = createContext();
const AppConfig = (props) => {
  const cookies = new Cookies();
  // console.log("appconfigprops", props);
  const dispatch = useDispatch();
  const { efficiency } = useSelector((state) => state);
  const { userName, userRole } = useSelector(
    (state) => state.common.loggedUser
  );
  const {
    CmdbListLoading,
    CmdbListData,
  } = useSelector((state) => state.appConfig);

  const {
    appCode,
    primaryManager,
    secondaryManager,
    businessUnit,
    approvalGate,
    criticality,
  } = get(efficiency, "appConfig.filterData");
  const tableData = get(efficiency, "appConfig.tableData", []);
  const isCancelNavigate = localStorage.getItem("isClicked");
  const pageNumber = Number(localStorage.getItem("CmdbPageNo"));
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [getcmdbCount] = effciencyApi.useLazyGetcmdbCountQuery();
  const [getcmdbList] = effciencyApi.useLazyGetcmdbListQuery();
  const [importCmdb] = effciencyApi.useImportCmdbMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [getBusinessInfoListCMDB] = effciencyApi.useGetBusinessInfoListCMDBMutation();
  const [getOperationRoleDetails] =
    effciencyApi.useLazyGetOperationRoleDetailsQuery();
  const [getcmdb] = effciencyApi.useLazyGetcmdbQuery();
  const proxy = GetProxy();

  const navigate = useNavigate();
  const [state, setState] = useState({
    limit: 10,
    page: 0,
    count: 0,
    totalPages: 1,
    modalOpenInfo: false,
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    loadPage: false,
    deleteModalOpen: false,
    importModal: false,
    file: "",
    fileInfo: "",
    initialLoad: true,
    alertMessage: "",
    businessInfoList: {},
    currentPageAPI: 0,
    conformationPop: false,
    fileError: ""
  });
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalPageCount, settotalPageCount] = useState();


  const getpayload = (key) => {
    const payload = {
      keyword: typeof (key) !== "undefined" ? key : searchKey,
    };
    return payload;
  };
  const fetchApiData = (page, limit, payload) => {
    dispatch(CmdbList({ page, limit, payload }));
  };

  const setLocalStorage = () => {
    localStorage.setItem("isClicked", true);
    localStorage.setItem("CmdbPageNo", page);
  };
  const removeLocalStorage = () => {
    localStorage.removeItem("isClicked");
    localStorage.removeItem("CmdbPageNo");
  };

  useEffect(() => {
    if (isCancelNavigate) {
      const payload = getpayload();
      fetchApiData(pageNumber, limit, payload);
      getBusinessInfoListCMDB()
        .unwrap()
        .then((data) => {
          setState((state) => ({
            ...state,
            businessInfoList: data,
          }));
        });
      setPage(pageNumber);
    } else {
      const payload = getpayload();
      fetchApiData(0, limit, payload);
      getBusinessInfoListCMDB()
        .unwrap()
        .then((data) => {
          setState((state) => ({
            ...state,
            businessInfoList: data,
          }));
        });
    }
  }, []);

  useEffect(() => {
    if (!isNaN(CmdbListData?.totalCount)) {
      const calculatedPageCount = Math.ceil(CmdbListData.totalCount / limit);
      const finalPageCount =
        calculatedPageCount !== 0 ? calculatedPageCount : 1;
      settotalPageCount(finalPageCount);
    }
  }, [CmdbListData.totalCount, limit]);

  const callAlert = (type, msg) => {
    callCommonAlert(type, msg);
    hideCommonAlert();
  };

  const handlePageLimitChange = (newPageLimit) => {
    if (newPageLimit === limit) {
      return;
    } else {
      const payload = getpayload();
      setLimit(newPageLimit);
      setPage(0);
      fetchApiData(0, newPageLimit, payload);
      removeLocalStorage();
    }
  };
  const handlePageNoChange = (pageNumber) => {
    if (pageNumber === page) {
      return;
    } else {
      const payload = getpayload();
      setPage(pageNumber);
      fetchApiData(pageNumber, limit, payload);
      removeLocalStorage();
    }
  };
  const onSearch = (e) => {
    setPage(0);
    setSearchKey(e);
    const payload = getpayload(e);
    fetchApiData(0, limit, payload);
    removeLocalStorage();
  };
  const handlsave = () => {
    const payload = getpayload();
    fetchApiData(0, limit, payload);
    setPage(0);
  };

  const appConfigtableHeaders = [
    {
      Header: "Application Details",
      className: "text-start",
      key: 1,
      accessor: "appCode",
      Cell: ({ row, value }) => (
        <div className="managerslist appname">
          <h5>
            <span title="Application Code">AC</span> {row.original.appCode}
          </h5>
          <h5>
            <span title="Application Name">AN</span> {row.original.appName}
          </h5>
        </div>
      ),
    },
    {
      Header: "Application Owner",
      className: "text-start",
      accessor: "primaryManager",
      key: 2,
      Cell: ({ row }) => (
        <div className="managerslist appname">
          <h5>
            <span title="Primary Owner">P</span> {row.original.primaryManager}
          </h5>
          <h5>
            <span title="Secondary Owner">S</span> {row.original.secondaryManager}
          </h5>
        </div>
      ),
    },

    {
      Header: "Criticality",
      accessor: "criticality",
      className: "text-start",
      key: 4,
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Business Department",
      accessor: "businessDepartment",
      className: "text-start",
      key: 5,
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Business Division",
      accessor: "businessUnit",
      className: "text-start",
    },
    {
      Header: "Projects",
      thClassName: "text-center",
      accessor: "projectCount",
      key: 6,
      Cell: ({ row }) => (
        <div className="noprojects table_icon" data-testid="projectCell">
          <BiSolidFolderOpen title="Projects"
            className="iconStyleProject"
            onClick={(e) => {
              e.preventDefault();
              setIsLoading(true);
              navigate(`/configuration/cmdb/${row.original.appName}/projects`, {
                state: { id: row.original.id, appName: row.original.appName },
              });
              setIsLoading(false);
              setLocalStorage();
            }}
          />
          <span className="noprojectcount">{row.original.projectCount}</span>

        </div>
      ),
    },
    {
      Header: "Users",
      thClassName: "text-center",
      accessor: "userCount",
      key: 8,
      Cell: ({ row }) => (
        <div className="tdactions justify-content-center " data-testid="userCell">
          <FaUserAlt
            onClick={() => {
              navigate(`/configuration/cmdb/${row.original.appName}/users`, {
                state: { id: row.original.id, appName: row.original.appName, },
              });
              setLocalStorage();
            }}
            title="Users"
            className="iconStyle usepointerpath"
            id="userIcon"
          />
          <span
            className="noprojectcount usepointerpath"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(`/configuration/cmdb/${row.original.appName}/users`, {
                state: { id: row.original.id, appName: row.original.appName, },
              });
              setLocalStorage();
            }}
          >
            {row.original.userCount}
          </span>

        </div>
      ),
    },
    props?.isDI ? null : {
      Header: "Devices",
      thClassName: "text-center",
      accessor: "serverCount",
      key: 7,
      Cell: ({ row }) => (
        <div className="tdactions justify-content-center" data-testid="deviceCell">
          <FaServer
            onClick={() => {
              navigate(`/configuration/cmdb/${row.original.appName}/Device`, {
                state: { id: row.original.id, appName: row.original.appName },
              });
              setLocalStorage();
            }}
            title="Devices"
            className="iconStyle usepointerpath"
            id="deviceIcon"
          />
          <span
            className="noprojectcount usepointerpath"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(`/configuration/cmdb/${row.original.appName}/Device`, {
                state: { id: row.original.id, appName: row.original.appName },
              });
              setLocalStorage();
            }}
          >
            {row.original.serverCount}
          </span>
        </div>
      ),
    },
    props?.isDI ? null : {
      Header: "Cloud Accounts",
      thClassName: "text-center",
      accessor: "accountIdCount",
      key: 9,
      Cell: ({ row }) => (
        <div className="tdactions justify-content-center" data-testid="cloudAccountCell">

          <FaCloud
            onClick={() => {
              navigate(`/configuration/cmdb/${row.original.appName}/CloudAccountIDs`, {
                state: {
                  id: row.original.id,
                  appCode: row.original.appCode,
                  appName: row.original.appName,
                },
              });
              setLocalStorage();
            }}
            title="Cloud Accounts"
            className="iconStyleCloud usepointerpath"
            id="cloudIcon"
          />
          <span
            className="noprojectcount usepointerpath"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(`/configuration/cmdb/${row.original.appName}/CloudAccountIDs`, {
                state: {
                  id: row.original.id,
                  appCode: row.original.appCode,
                  appName: row.original.appName,
                },
              });
              setLocalStorage();
            }}
          >
            {row.original.accountIdCount}
          </span>
        </div>
      ),
    },
    {
      Header: "Actions",
      accessor: "Action",
      thClassName: "text-center",
      disableSortBy: true,
      key: 10,
      Cell: ({ row }) => (
        <div className="tdactions justify-content-center" data-testid="actionsCell">
          {" "}
          {props?.isDI ? null : <div>
            <div className="actcol">

              <IoMdSettings
                title="Configuration"
                className="iconStyleActions"
                data-testid="settingsIcon"
                src={settingsCode8}
                onClick={() => {
                  navigate("/configuration/cmdb/applicationConfiguration", {
                    state: { id: row.original.id },
                  });
                  setLocalStorage();
                }}
              />
            </div>
          </div>}
          <div className="actcol">
            <FiEdit
              title="Edit"
              className="iconStyleActions"
              data-testid="editIcon"
              style={{ cursor: 'pointer', width: '20px', height: '20px' }}
              onClick={() => {
                setState((state) => ({
                  ...state,
                  applicationConfig: true,
                  appConfigTitle: "Update CMDB Configuration",
                  cmdbId: row.original.id,
                }));
              }}
            />
          </div>
          <div className="actcol">
            <FiTrash2
              title="Delete"
              className="iconStyleActions"
              data-testid="deleteIcon"
              style={{ cursor: 'pointer', width: '20px', height: '20px' }}
              onClick={() => {
                setState((state) => ({
                  ...state,
                  cmdbId: row.original.id,
                  deleteModalOpen: true,
                }));
              }}
            />
          </div>
        </div>
      ),
    },
  ].filter(Boolean);

  const filteredJson =
    props.page === "configuration"
      ? appConfigtableHeaders.filter((obj) => obj.key !== 3 && obj.key !== 6) // Remove "Approval Gate" object for configuration page
      : appConfigtableHeaders;

  const getCmdbLists = async (appInfo = {}) => {
    const tableData = !isEmpty(CmdbListData)
      ? CmdbListData.data.map((list) => {
        let gate = list.approvalGate > 0 ? "Yes" : "No";
        return {
          ...list,
          isApprovalGate: gate,
        };
      })
      : [];
    console.log(state.initialLoad);
    if (state.initialLoad) {
      console.log(appInfo);
      dispatch(
        setAppConfig(get(efficiency, "appConfig"), {
          tableData,
          appNameCode: appInfo.appNameCode,
          managerList: appInfo.managerList,
        })
      );
    } else {
      dispatch(
        setAppConfig(get(efficiency, "appConfig"), {
          tableData,
        })
      );
    }
    setState((state) => ({
      ...state,
      initialLoad: false,
    }));
  };
  const setAppFilter = async () => {
    const { data: appNameCode } = await getcmdb();
    console.log('appNameCode: ', appNameCode);
    const { data: managerList } = await getOperationRoleDetails();
    console.log('managerList: ', managerList);
    return { appNameCode, managerList };
  };

  useEffect(() => {
    console.log(userName, userRole);
    if (userName !== "" && userRole.length > 0) {
      async function fetchData() {
        try {
          const appInfo = state.initialLoad && (await setAppFilter());
          console.log(appInfo);
          getCmdbLists(appInfo);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
      fetchData();
      setState((state) => ({
        ...state,
        currentPageAPI: state.page,
      }));
    }
    return () => {
      dispatch(
        setAppConfig(get(efficiency, "appConfig"), {
          filterData: {
            appCode: "",
            applicationName: "",
            primaryManager: "",
            secondaryManager: "",
            businessUnit: "",
            criticality: "",
            approvalGate: 0,
          },
        })
      );
    };
  }, [userName, userRole, state.page, state.limit, state.loadPage]);

  // eslint-disable-next-line react/display-name, react/prop-types
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <img src={iconElipsis} />
    </a>
  ));
  const handleImportModalClose = () => {
    setState({
      ...state,
      importModal: false,
    });
  };
  const DownloadStatusfile = () => {
    fetch("/downloadPDF?fileName=importAppConfigStatus").then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Status.pdf";
        a.click();
      });
    });
  };
  const postImportCmdb = () => {
    if (state.file === "") {
      setState({
        ...state,
        fileError: "*Please choose the File",
        importModal: true,
      });
      return "";
    }
    const formData = new FormData();
    formData.append("file", state.file);
    importCmdb({ formData, userName })
      .then((data) => {
        if (data.error && data.error.data === "Please upload a csv file!") {
          setState((state) => ({
            ...state,
            importModal: false,
            loadPage: true,
            file: "",
            fileInfo: "",
            fileError: "",
          }));
          callCommonAlert("error", "Please upload a csv file");
          hideCommonAlert();
        } else {
          callCommonAlert("success", () => (
            <>
              <span>Import configuration item completed successfully.</span>
              <a
                onClick={DownloadStatusfile}
                style={{ textDecoration: "underline", color: "#f6a821" }}
              >
                Download: Status
              </a>
            </>
          ));
          hideCommonAlert();
          const payload = getpayload("");
          fetchApiData(0, 10, payload);
          setState({
            ...state,
            importModal: false,
            loadPage: true,
            file: "",
            fileInfo: "",
            fileError: "",
          });
        };
      })
      .catch((error) => console.log(error));
  };
  const ProjectSample = () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

    fetch(`${proxy}/cmdb/api/v1/cmdb/template/${props.page === "configuration" ? "CMDB" : "appConfig"}`, {
      method: 'GET',
      headers: {
        'DTOP-API-TOKEN': apiToken,
        'USERNAME': username
      }
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "App_Config_Template.csv";
        a.click();
      });
    });
  };
  const importModal = () => (
    <>
      <h4>Import Configuration Item</h4>
      <div className="errors">{state.fileError}</div>
      <form id="upload-file-form"
        className="hide-ele"
        data-testid="importCmdbForm" >
        <div className="col-lg-12 upload-file-model">
          <label
            className="btn btn-submit chaos-btn ml-0 upload_btn"
            htmlFor="upload-file-input"
          >
            <input
              id="upload-file-input"
              type="file"
              accept=".csv"
              name="file"
              className="hide-ele"
              onChange={(event) => {
                setState({
                  ...state,
                  file: event.target.files[0],
                  fileInfo: event.target.files[0].name,
                  fileError: "",
                });
              }}
            />
          </label>
          <span className="label label-default hide filepath" id="upload-file-info">
            {state.fileInfo !== ""
              ? "C:\\fakepath\\" + `${state.fileInfo}`
              : ""}
          </span>
          <div className="col-md-12 upload_example">
            <a onClick={ProjectSample}>App_Config_Template.csv</a>
          </div>
        </div>
      </form>
      <div className="btnswrap">
        <ButtonComponent text="Cancel" onClick={handleImportModalClose} className="cancelBtnStyle" data-testid="cancelImportBtn" />
        <ButtonComponent text="Submit" onClick={postImportCmdb} data-testid="submitImportBtn" />

      </div>
    </>
  );

  const exportCmdb = () => {
    const payload = getpayload();
    dispatch(exportCmdbAppConfigCSV(payload))
      .then((action) => {
        if (exportCmdbAppConfigCSV.fulfilled.match(action)) {
          const blob = action.payload;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Cmdb.csv";
          a.click();
          callAlert("success", "CMDB data exported successfully!");
        } else {
          callAlert("error", "Failed to export CMDB data");
          console.error('Export failed:', action.payload);
        }
      })
      .catch((error) => {
        callAlert("error", "Something went wrong while exporting");
        console.error('Export error:', error);
      });
  };

  const handleCloseInfo = () => {
    setState({
      ...state,
      modalOpenInfo: false,
    });
  };

  const handleShowInfo = (appName, description) => {
    setState({
      ...state,
      appName: appName,
      description: description,
      modalOpenInfo: true,
    });
  };
  const modalBodyInfo = () => (
    <>
      <div>
        <h4 className="actionDescription mb-3">
          {!isEmpty(state.appName) ? state.appName : "-"}
        </h4>
        <div className="infoBody">
          <h6 className="text-start  fw-bolder">Application Description</h6>
          <p className="text-start">
            {!isEmpty(state.description) ? (
              state.description
            ) : (
              <span style={{ color: "red" }}>Not Available</span>
            )}
          </p>
        </div>
      </div>
    </>
  );
  const headers = [...filteredJson];

  const additionalBtnData = [

    {
      text: "Export",
      btnComponent: (
        <div>
          <span
            className="d-inline-block Custom_tooltip"
            tabIndex="0"
          >
            {/* Use ShowTooltip for the tooltip functionality */}
            <ShowTooltip
              epssClassName="Custom_tooltip"
              value="Export as CSV"
              placement="top"
            />
            {/* Export Button */}
            <ButtonComponent
              className={`btnStyle export-btn`}
              disabled={props.vmCurrentListDatadrilldown?.content?.length === 0}
              data-testid="vmCsvBtn"
              style={{ minWidth: "3px", marginLeft: "0px" }}
              text={<span><TiExport style={{ fontSize: "21px" }} /></span>}
              onClick={exportCmdb}
            />
          </span>
        </div>
      )
    },
    {
      text: "Import",
      btnComponent: (
        <div>
          <span
            className="d-inline-block Custom_tooltip"
            tabIndex="0"
          >
            {/* Use ShowTooltip for the tooltip functionality */}
            <ShowTooltip
              epssClassName="Custom_tooltip"
              value="Import as CSV"
              placement="top"
            />
            {/* Export Button */}
            <ButtonComponent
              data-testid="vmCsvBtn"
              className={`serverTableAddList btnStyle export-btn`}
              style={{ minWidth: "3px", marginLeft: "0px" }}
              text={<span><BiImport style={{ fontSize: "21px" }} /></span>}
              onClick={() => {
                setState({
                  ...state,
                  importModal: true,
                  file: "",
                  fileInfo: "",
                });
              }}
            />
          </span>
        </div>
      )
    },
    // {
    //   text: ":",
    //   btnComponent: (
    //     <>
    //       <div className="dropdown secdrop" style={{ margin: "8px -20px 0px 0px" }}>
    //         <Dropdown>
    //           <Dropdown.Toggle as={CustomToggle} />
    //           <Dropdown.Menu size="sm" title="">
    //             <Dropdown.Item
    //               onClick={() => {
    //                 setState({
    //                   ...state,
    //                   importModal: true,
    //                   file: "",
    //                   fileInfo: "",
    //                 });
    //               }}
    //             >
    //               <span>
    //                 <img src={fileImport} alt="import.png" />
    //               </span>
    //               Import Configuration Item
    //             </Dropdown.Item>
    //             <Dropdown.Item onClick={() => exportCmdb()}>
    //               <span>
    //                 <img src={fileExport} alt="export.png" />
    //               </span>
    //               Export Configuration Item
    //             </Dropdown.Item>
    //           </Dropdown.Menu>
    //         </Dropdown>
    //       </div>
    //     </>
    //   ),
    // },
    {
      text: "New CMDB Configuration",
      btnComponent: (
        <>
          <button
            onClick={() =>
              setState((state) => ({
                ...state,
                applicationConfig: true,
                conformationPop: false,
                appConfigTitle: "New CMDB Configuration",
              }))
            }
            className="solid-btn"
            data-testid="addCmdbConfigBtn"
          >
            Add
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="p-0-5 cmdbPage">
        <AppConfigContext.Provider value={{ state, setState }}>
          {!state.applicationConfig ? (
            <>
              <div className="fltractnav">
                <DeleteModal fetchApiData={fetchApiData} getpayload={getpayload} />
                <CustomModal
                  modalBody={importModal}
                  modalHide={handleImportModalClose}
                  modalOpen={state.importModal}
                />
              </div>
              <div className="main-content-wrap appwrap" data-testid="cmdbConfigMainDiv">
                <div className="grid-table " >
                  {/* {CmdbCountLoading || CmdbListLoading ? (
                    <Spinners />
                  ) : ( */}
                  <CompleteTableData
                    isLoading={CmdbListLoading}
                    data={CmdbListData?.data || []}
                    tbodyClass={"text-business"}
                    columns={filteredJson}
                    listCount={CmdbListData?.totalCount}
                    pageLimit={limit}
                    onSearch={onSearch}
                    onPageNoChange={handlePageNoChange}
                    onPageLimitChange={handlePageLimitChange}
                    searchKey={searchKey}
                    totalPageCount={totalPageCount}
                    curentPageNumber={page}
                    additionalBtnData={additionalBtnData}
                    moveSearchToEnd={true}
                  />
                  {/* ) */}
                  {/* } */}
                </div>
              </div>
              <CustomModal
                modalOpen={state.modalOpenInfo}
                modalBody={modalBodyInfo}
                modalHide={handleCloseInfo}
                closeBtn={true}
                closeBtnFuc={handleCloseInfo}
                size={"lg"}
              />
            </>
          ) : (
            <NewCmdbConfig page={props.page} conformationPop={state.conformationPop} cmdbId={state.cmdbId} businessInfoList={state.businessInfoList} handlesave={handlsave} getpayload={getpayload} fetchApiData={fetchApiData} callAlert={callAlert} />
          )}
        </AppConfigContext.Provider>
      </div>
    </>
  );
};
export default AppConfig;
